import { groupsBuddiesActionNames } from "./actions";

const initialState = {
  isGroup: false,
  isBuddy: false,
  isUser: false,
  profilePicture: "",
  displayName: "",
  lastActiveTime: 0,
  studyTime: 0,
  description: "",
  privacy: "",
  members: [],
  isMember: false,
};

export const groupsBuddiesDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case groupsBuddiesActionNames.SET_BUDDY_PROFILE_FLAG: {
      return { ...state, isBuddy: action.payload };
    }
    case groupsBuddiesActionNames.SET_USER_PROFILE_FLAG: {
      return { ...state, isUser: action.payload };
    }
    case groupsBuddiesActionNames.SET_GROUP_FLAG: {
      return { ...state, isGroup: action.payload };
    }
    case groupsBuddiesActionNames.SET_PROFILE_PICTURE: {
      return { ...state, profilePicture: action.payload };
    }
    case groupsBuddiesActionNames.SET_DISPLAYNAME: {
      return { ...state, displayName: action.payload };
    }
    case groupsBuddiesActionNames.SET_LAST_ACTIVE_TIME: {
      return { ...state, lastActiveTime: action.payload };
    }
    case groupsBuddiesActionNames.SET_STUDY_TIME: {
      return { ...state, studyTime: action.payload };
    }
    case groupsBuddiesActionNames.SET_DESCRIPTION: {
      return { ...state, description: action.payload };
    }
    case groupsBuddiesActionNames.SET_PRIVACY: {
      return { ...state, privacy: action.payload };
    }
    case groupsBuddiesActionNames.SET_MEMBERS: {
      return { ...state, members: action.payload };
    }
    case groupsBuddiesActionNames.SET_MEMBER_FLAG: {
      return { ...state, isMember: action.payload };
    }
    default:
      return state;
  }
};
